import { render, staticRenderFns } from "./DashboardManager.vue?vue&type=template&id=b92be7d0&scoped=true"
import script from "./DashboardManager.vue?vue&type=script&lang=js"
export * from "./DashboardManager.vue?vue&type=script&lang=js"
import style0 from "./DashboardManager.vue?vue&type=style&index=0&id=b92be7d0&prod&scoped=true&lang=css"
import style1 from "./DashboardManager.vue?vue&type=style&index=1&id=b92be7d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92be7d0",
  null
  
)

export default component.exports